<template>
    <v-container fluid class="main-container px-0 mx-0">
      <v-row style="height: auto" class="px-0 mx-0">
        <!-- menu section -->
        <v-col cols="12"  md="4" sm="12" class="mx-0 px-0 d-none d-md-block">
         <v-row class="mx-0 px-0">
           <v-col cols="12" class="px-0 mx-0 side-bar-header-section"/>
           <v-col cols="12" class="side-section px-0 mx-0 d-flex flex-column  justify-end">
             <div class="offset-1 px-0" style="max-width: 30vw; min-height: 70vh">
                 <v-btn color="secondary" elevation="0" class="mb-5" style="border-radius: 2em; color: #0033AA" to="/home">
                   <v-icon color="primary">mdi-home</v-icon> Back to Home
                 </v-btn>
                 <v-card class="profile-details-card py-3" flat> 
                  <SideMenu/>
                 </v-card>
             </div>
           </v-col>
         </v-row>
        </v-col>
        <!-- end of menu section -->
        <v-col cols="12" md="8" sm="12" class="px-0 mx-0">
          <v-row class="mx-0 px-0">
            <v-col cols="12" class="mx-0 px-0 header-div" style="height: 20vh; position: relative; background-color: #0033AA">
              <v-btn text class="align-self-end pa-5 mx-1  d-md-none"  color="white">
                <v-icon
                  right
                  dark
                  class="mx-2 "
                  to="/home"
                >
                  mdi-chevron-left 
                </v-icon>
                Back
              </v-btn>
            </v-col>
            <v-col cols="12" class="mx-0  px-0 my-4 pr-4">
              <v-row>
                <v-col cols="12" class="ml-2 pt-1">
                  <v-card flat class="right-section">
                   <router-view></router-view>
                  </v-card>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
      <LogOutDialog
          :reveal="showLogOutDialog"
          @cancel="showLogOutDialog = false"
          @logOutSuccess="showLogOutDialog = false"
      />
    </v-container>
  </template>
  <script>

  import authDialogMixin from "@/mixins/authDialogMixin";
  import LogOutDialog from "@/components/LogOutDialog";
  import SideMenu from '@/views/profile/SideMenu.vue';

  
  export default {
    name: "DesktopMentorProfile",
    mixins: [authDialogMixin],
    components: { LogOutDialog,SideMenu},
    data() {
      return { 
        tab: 0,
        showLogOutDialog: false
       }
    },
  }
  </script>
  <style lang="scss" scoped>
  @import "~vuetify/src/styles/settings/_variables";
  .v-btn {
    text-transform: none !important;
  }
  .main-container {
    background-color: #EAEFF9;
    min-height: 100vh;
    font-family: Montserrat, sans-serif;
  }
  .side-section {
    position: absolute;
    height: 70vh;
    top: 8vh;
  }
  
  .side-bar-header-section {
    height: 20vh;
    position: relative;
    background-color: #0033AA;
  }
  
  .profile-details-card {
    height: 100%;
    background-color: white;
    border-radius: 1em;
    width: 75%
  }
  
  .activity-card {
    width: 72%;
    background-color: rgba(217, 217, 217, 0.37);
    border: .1em solid #909090;
  }
  
  .right-section {
    height: 70vh;
    background-color: white;
    border-radius: 1em;
    width: 100%;
    margin:auto;
    overflow-y: scroll;
    overflow-x: hidden;
    scrollbar-width: 10px;
  
  }
  .right-section::-webkit-scrollbar {
    width: 10px;
    
  }
  .right-section::-webkit-scrollbar-thumb {
    background-color: rgb(9, 117, 119);
    border: 5px solid rgb(9, 117, 119);
    border-radius: 1em;
    margin-top:10px;
  }
  .active-tab {
    border: none;
    background-color: #0033AA;
    border-radius: 2em;
    width: 10em;
    color: white !important;
    margin-bottom: .4em;
  }
  
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    .header-div {
      height: 100px !important;
    }
  }
  </style>
  